module.exports = __webpack_public_path__ + "static/media/loader.963d6134.svg";